import React from "react";
import { Table, Tr, Td, Th, Thead, Tfoot } from "reactable";
import { LoadingShadeTile } from "./components/LoadingShadeTile/LoadingShadeTile";

export const SmartTable = ({ data, columns, isLoading, error }) => {
  return (
    <Table className="table" noDataText="No matching records found">
      <Thead>
        {columns.map((m) => (
          <Th key={m.title} column={m.title}>
            <strong>{m.title}</strong>
          </Th>
        ))}
      </Thead>

      {isLoading && data && data.length === 0 && (
        <Tr>
          {columns.map((c) => (
            <Td key={c.title} column={c.title}>
              <LoadingShadeTile />
            </Td>
          ))}
        </Tr>
      )}

      {error && (
        <Tfoot>
          <div style={{ padding: "12px", color: "red" }}>Could not fetch data, something went wrong!</div>
        </Tfoot>
      )}

      {data.map((m, index) => (
        <Tr key={index}>
          {columns.map((c) => (
            <Td key={c.title} column={c.title}>
              {isLoading ? <LoadingShadeTile /> : c.render(m)}
            </Td>
          ))}
        </Tr>
      ))}
    </Table>
  );
};
